!<template>
	<div>
		<h1>커뮤니티</h1>
		<div class="community-main basic-container" style="margin-bottom:20px">
			<div class="community-top">
				<div class="notice_tit"><p>공지사항</p></div>
				<button type="button" name="addRow" class="community-btn_more greenBtn tiny mr-2" @click="goBoardList('notice')">+더보기</button>
				<div class="community-notice notice_area">
					<NoticeList></NoticeList>
				</div>
			</div>
		</div>

		<div class="community-btm">
			<div class="community-btm-l">
				<div class="community-main basic-container community_h">
					<div class="community-top">
						<div class="notice_tit"><p>자료실</p></div>
						<button type="button" name="addRow" class="community-btn_more greenBtn tiny mr-2" @click="goBoardList('data')">+더보기</button>
						<div class="community-data">
							<DataList></DataList>
						</div>
					</div>
				</div>
			</div>

			<div class="community-btm-r">
				<div class="community-main basic-container community_h" style="margin-bottom:40px">
					<div class="community-top">
						<div class="notice_tit"><p>Q&A</p></div>
						<div class="community-qna">
							<div class="community-contents-box community_h02">
								<div class="qna_area">
									<p>문의하실 사항이 있으시면 1:1 상담을 이용하세요.</p>
									<button class="greenBtn" @click="goConsult">1:1상담하기</button>
								</div>
							</div>
						</div>
						<!-- <div class="notice_tit">
							<p>
								쪽지함
								<span class="memo_tit">({{ messageCnt01 }}건<b v-text="messageCnt02"></b>건)</span>
							</p>
						</div>
						<div class="community-msg">
							<div class="community-contents-box community_h02">
								<div class="memo_area">
									<button class="greenBtn" @click="goSendedMessage">보낸쪽지함</button>
									<button class="greenBtn" @click="goReceivedMessage">받은쪽지함</button>
								</div>
							</div>
						</div> -->
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import CONST from '@/constants';
import NoticeList from '@/components/community/NoticeList.vue';
import DataList from '@/components/community/DataList.vue';

export default {
	title: '커뮤니티 메인',
	name: 'CommunityMain',
	components: { NoticeList: NoticeList, DataList: DataList },
	data: function() {
		return {
			loginMember: null,
			messageCnt01: 0,
			messageCnt02: 0,
		};
	},
	created() {
		let dt = this.$device.loadLocalData('LOGIN_USER');
		if (dt) this.loginMember = JSON.parse(dt);
	},
	mounted() {
		this.getMessageCnt();
		this.$device.sendEvent(CONST.EVENTS.SET_SIDE_MENU, 'COMMUNITY');
	},
	methods: {
		goBoardList: function(type) {
			this.$device.closeSideMenu();
			this.$device.pushView('/board/' + type);
			this.$device.sendEvent(CONST.EVENTS.SET_SIDE_MENU, 'COMMUNITY');
		},
		goConsult: function() {
			this.$device.closeSideMenu();
			this.$device.pushView('/qna/consult');
			this.$device.sendEvent(CONST.EVENTS.SET_SIDE_MENU, 'COMMUNITY');
		},
		goSendedMessage: function() {
			this.$device.closeSideMenu();
			this.$device.pushView('/qna/send');
			this.$device.sendEvent(CONST.EVENTS.SET_SIDE_MENU, 'COMMUNITY');
		},
		goReceivedMessage: function() {
			this.$device.closeSideMenu();
			this.$device.pushView('/qna/receive');
			this.$device.sendEvent(CONST.EVENTS.SET_SIDE_MENU, 'COMMUNITY');
		},
		getMessageCnt: function() {
			this.messageCnt01 = 1;
			this.messageCnt02 = 3;
		},
	},
};
</script>

<style scoped></style>
